import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const getOwnershipSummary = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/summary`);

/** Summary cards on the Property Ownership screen. */
const useGetOwnershipSummary = ({ communityId }: { communityId: string }): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-summary", communityId],
    queryFn: () => getOwnershipSummary(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId && communityId != "all",
  });
};

export default useGetOwnershipSummary;
